if (!customElements.get("open-gift-panel")) {
  customElements.define(
    "open-gift-panel",
    class OpenGiftPanel extends HTMLElement {
      constructor() {
        super();

        this.addEventListener("click", () => {
          const target = document.getElementById(this.dataset.target);
          target.classList.add("active");
        });
      }
    }
  );
}

if (!customElements.get("gift-panel")) {
  customElements.define(
    "gift-panel",
    class GiftPanel extends HTMLElement {
      constructor() {
        super();

        this.close = this.querySelector(".gift-panel__close");
        this.close.addEventListener("click", this.closePanel.bind(this));

        this.threshold = +this.dataset.threshold;

        this.cartUpdateUnsubscriber = null;
      }

      closePanel() {
        this.classList.remove("active");
      }
    }
  );
}

if (!customElements.get("sticky-steps")) {
  customElements.define(
    "sticky-steps",
    class StickySteps extends HTMLElement {
      constructor() {
        super();

        this.parent = this.closest(".shopify-section-sticky-steps");

        this.stickyStepsSwiper = new Swiper(this.querySelector(".swiper"), {
          slidesPerView: "auto",
          spaceBetween: 30,
          navigation: {
            prevEl: this.querySelector(".swiper-button-prev"),
            nextEl: this.querySelector(".swiper-button-next"),
          },
        });

        this.initScrollObserver();
        this.initAnchorNavigation();
      }

      initAnchorNavigation() {
        const anchorLinks = this.querySelectorAll('a[href^="#"]');

        anchorLinks.forEach(link => {
          link.addEventListener("click", e => {
            e.preventDefault();

            const targetId = link.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
              const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
              const offsetPosition = elementPosition - 100;

              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              });
            }
          });
        });
      }

      initScrollObserver() {
        const checkPosition = () => {
          const rect = this.parent.getBoundingClientRect();
          const topPosition = rect.top;

          if (topPosition <= 64) {
            this.parent.classList.add("active");
          } else {
            this.parent.classList.remove("active");
          }
        };

        checkPosition();

        this.scrollHandler = checkPosition;
        window.addEventListener("scroll", this.scrollHandler, {
          passive: true,
        });
      }

      disconnectedCallback() {
        if (this.scrollHandler) {
          window.removeEventListener("scroll", this.scrollHandler);
        }
      }
    }
  );
}

if (!customElements.get("cross-sell-slider")) {
  customElements.define(
    "cross-sell-slider",
    class CrossSellSlider extends HTMLElement {
      constructor() {
        super();
        this.isDragging = false;
        this.startX = 0;
        this.scrollStart = 0;

        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseUpOrLeave = this.onMouseUpOrLeave.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
      }

      connectedCallback() {
        this.addEventListener("mousedown", this.onMouseDown);
        this.addEventListener("mouseup", this.onMouseUpOrLeave);
        this.addEventListener("mouseleave", this.onMouseUpOrLeave);
        this.addEventListener("mousemove", this.onMouseMove);
      }

      disconnectedCallback() {
        this.removeEventListener("mousedown", this.onMouseDown);
        this.removeEventListener("mouseup", this.onMouseUpOrLeave);
        this.removeEventListener("mouseleave", this.onMouseUpOrLeave);
        this.removeEventListener("mousemove", this.onMouseMove);
      }

      onMouseDown(e) {
        this.isDragging = true;
        this.classList.add("active");
        this.startX = e.pageX - this.offsetLeft;
        this.scrollStart = this.scrollLeft;
      }

      onMouseUpOrLeave() {
        this.isDragging = false;
        this.classList.remove("active");
      }

      onMouseMove(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.pageX - this.offsetLeft;
        const walk = x - this.startX;
        this.scrollLeft = this.scrollStart - walk;
      }
    }
  );
}
$("[data-drawer-handle]").on("click", function (e) {
  e.preventDefault();

  if ($(this).closest("[data-drawer]").attr("data-drawer") === "expanded") {
    $(this).closest("[data-drawer]").attr("data-drawer", "");
  } else {
    $(this).closest("[data-drawer]").attr("data-drawer", "expanded");
  }
});

const InputChecked = {
  init: function () {
    this.initCheckboxes();
  },
  initCheckboxes: function () {
    $(".unique-selected-checkbox").each(function () {
      var currentElement = $(this);
      currentElement.find('input[type="checkbox"]').on("change", function () {
        currentElement.find('input[type="checkbox"]').not(this).prop("checked", false);
      });
    });
  },
};

InputChecked.init();
//# sourceMappingURL=theme-custom.js.map
